import { Component, inject, OnInit } from "@angular/core";
import { DefaultComponent } from "@kpx/core";
import { HttpService } from "@kpx/http";
import { IEmbedConfiguration, models } from "powerbi-client";
import { PowerBIEmbedModule } from "powerbi-client-angular";
import { API_ROUTES } from "../../../api.config";

export interface PowerBiResponse {
  embedUrl: string;
  id: string;
  token: string;
}

@Component({
  selector: "app-powerbi",
  imports: [PowerBIEmbedModule],
  templateUrl: "./powerbi.component.html",
  styleUrl: "./powerbi.component.less",
})
export class PowerbiComponent extends DefaultComponent implements OnInit {
  private http: HttpService;
  public config: IEmbedConfiguration | null;
  public error: boolean;

  public constructor() {
    super();
    this.config = null;
    this.http = inject(HttpService);
    this.error = false;
  }

  public async ngOnInit(): Promise<void> {
    try {
      const res = await this.http.post<PowerBiResponse>(API_ROUTES.getMJOPReport, {
        type: "MJOP",
      });

      this.config = {
        type: "report",
        id: res.id,
        embedUrl: res.embedUrl,
        accessToken: res.token,
        tokenType: models.TokenType.Embed,
        hostname: "https://app.powerbi.com",
        settings: {
          filterPaneEnabled: true,
          panes: {
            filters: {
              visible: true,
            },
            pageNavigation: {
              visible: true,
            },
          },
        },
      };
    } catch (error) {
      this.error = true;
    }
  }
}
